export enum ColumnDataTypeEnum {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  RENDER_HTML = 'render_html',
  BUTTON = 'button',
  EXPORT = 'export',
  EXPANDED = 'expanded',
  NESTED_TABLE = 'nested_table',
  OPTIONS = 'options'
}

export enum SubDataTypeEnum {
  CURRENCY = "currency",
  SSN = 'ssn',
  PERCENTAGE = 'percentage',
  ZIPCODE = 'zipcode',
  CREDIT_CARD_TYPE = 'creditCardType',
  TIME_EST = 'timeEst'
}

export enum FilterTypeEnum {
  EQUALS = 'equals',
  BETWEEN = 'between'
}

export interface IFilterInputModel {
  type: ColumnDataTypeEnum;
  value: any;
}

export interface IFiltersValuesModel {
  filterType: FilterTypeEnum,
  type: ColumnDataTypeEnum;
  name: string,
  value: string[]
}

